export const RELATIVE_TIMESTAMP_FORMATS = {
    FROM_NOW: 'fromNow',
    TO_NOW: 'toNow',
    CALENDAR: 'calendar',
    HOUR_HYBRID: 'hourHybrid',
} as const;

export type RelativeTimestampFormat =
    (typeof RELATIVE_TIMESTAMP_FORMATS)[keyof typeof RELATIVE_TIMESTAMP_FORMATS];
